import { DisplayValue } from '@adaptiva/core/common';
import { ESecurityExposureLevel, MetadataSerialization, RiskProperties } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-risk-properties',
	templateUrl: './risk-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiskPropertiesComponent extends BaseAuthoringPropertiesComponent<RiskProperties> {

	public propertyConstructor: MetadataSerialization.Deserializable<RiskProperties> = RiskProperties;

	public securityExposureLevelOptions: DisplayValue<number>[] = [
		{ display: 'Low', value: ESecurityExposureLevel.LOW },
		{ display: 'Medium', value: ESecurityExposureLevel.MEDIUM },
		{ display: 'High', value: ESecurityExposureLevel.HIGH },
		{ display: 'Critical', value: ESecurityExposureLevel.CRITICAL }
	];

	public setCvssScores(_scores: string[]): void {
		this.setObjectPropertyValue('CvssScores', _scores.map(_score => +_score));
	}

	public setCveIds(_ids: string[]): void {
		this.setObjectPropertyValue('CveIds', _ids.map((_cve: string) => _cve.trim()));
	}

}
